module.exports = __webpack_public_path__ + "trunking-bottom.svg?1c218fd5f0f1046e7a045a185c4cb38f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/trunking-bottom.svg
// module id = 84
// module chunks = 0